// Pit Report sign-up in the footer: POST /newsletter (no CSRF token
// on cached pages; the server checks Origin and a honeypot field).
const form = document.querySelector<HTMLFormElement>('[data-newsletter]')

if (form) {
  const status = form.querySelector<HTMLElement>('[data-newsletter-status]')!
  const button = form.querySelector<HTMLButtonElement>('button[type="submit"]')!
  const say = (message: string, error = false) => {
    status.hidden = false
    status.textContent = message
    status.classList.toggle('accent', !error)
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault()
    button.disabled = true
    try {
      const response = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      const data = await response.json().catch(() => ({}))
      if (response.ok) {
        say(data.message ?? 'Check your inbox to confirm.')
        form.querySelector<HTMLInputElement>('input[type="email"]')!.value = ''
      } else {
        say(data.error ?? 'Something went wrong. Try again in a minute.', true)
      }
    } catch {
      say('No connection. Try again in a minute.', true)
    } finally {
      button.disabled = false
    }
  })
}
